import Box from '@mui/material/Box';

/**
 * Ancho máximo + padding horizontal responsivo del sitio.
 * `wide` usa el ancho del nav (1240) en vez del de contenido (1180).
 */
export default function Container({
  wide = false,
  sx = {},
  children,
  ...props
}) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: wide ? 1240 : 1180,
        mx: 'auto',
        px: 'clamp(20px, 4vw, 44px)',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
